import { useRef, useState, useEffect } from "react";
import sampPdf from '../../uploads/sample.pdf'
import { randomUUID } from '../../utils/randomUUID';

const Table = (props) => {
  const thData =  props !='undefined' &&  props?.data !='undefined' && props?.data ? Array.isArray(props.data) ? props?.data[0] : ['Skill Set','Proficiency'] : [];
  console.log('thData1',thData);
  const trRef = useRef(null);
  const [moreText, setMoreText] = useState("View More");
  const [showViewMore, setShowViewMore] = useState(false);
  const [showRow, setShowRow] = useState("hidden");

  let tdCont = [];
  let trRow = 0;
  
  if (typeof props?.data != 'undefined' && props?.data != '' && props?.from != 'lattice') {
    console.log(props);
    props?.data?.map((content, idx) => {
      if (idx !== 0) {
        let tdRowCont = [];
        content.map((value) => {
          tdRowCont.push(value);
        });
        tdCont.push(tdRowCont);
      }
    });
  } else {
    let dataVal=  props?.from == 'lattice' ? props?.data?.split('@@@'):[];
    console.log('dataValS',dataVal);
    let dataVal1 = dataVal.length > 0 ? dataVal[0]?.split(","):[];
    let dataVal2 = dataVal.length > 0 ? dataVal[1]?.split(","):[];
    let datfullconval = dataVal.length > 0 ? dataVal[0]?.split(","):[];
    datfullconval?.map((content, idx) => {
      let tdRowCont = [];
      console.log('dataVal1[idx]b4',dataVal1[idx]);
      if((dataVal1[idx]!='undefined' ||  dataVal2[idx]!='undefined') && (dataVal1[idx]!==undefined || dataVal2[idx]!==undefined) ){
        let comp=dataVal1[idx]+'@@@'+dataVal2[idx];
        console.log('dataVal1[idx]',dataVal1[idx]);
        tdRowCont.push(comp);
        tdCont.push(tdRowCont);
      }else{
        if(idx <1 ) {
        let comp='No data available @@@ No data available ';
        tdRowCont.push(comp);
        tdCont.push(tdRowCont);
        }
          
        
      }
    });
  }

  useEffect(() => {
    tdCont.length > 2 ? setShowViewMore(true) : setShowViewMore(false);
    tdCont.length > 2 ? setShowRow("hidden") : setShowRow("opened");
  }, [])

  function showMore (){
    setShowRow(showViewMore ? "" : "hidden");
    setMoreText(showViewMore ? "View Less" : "View More")
    setShowViewMore(!showViewMore);
  }

  function TableRow(row) {
    trRow = row.index;
    return (
      <tr className={trRow > 2 ? showRow : ""}>
        {row?.rowContent?.map((val, idx) => {
          return val?.indexOf('http') != -1 ? <td key={randomUUID()}><a className='mt-[3px] block' href={val} target='__blank'>View</a></td> : val.indexOf("@@@")!=-1 ? val.split("@@@").map(v=>{
            return <td key={randomUUID()}>{v}</td>
          }) :val!=null ? <td key={randomUUID()}>{val}</td>:""
        })}
      </tr>
      
    )
  }


  return (
    <>
    <table className="min-w-full">
      {thData.length > 0 ? <thead className="">
        <tr>
          {thData?.map((heading) => (
            <th key={randomUUID()}>{heading}</th>
          ))}
        </tr>
      </thead> : ""}
      
      <tbody className="divide-y divide-gray-200 bg-white" ref={trRef}>
        {tdCont.map((rowContent, idx) => {
          return <>
            <TableRow key={randomUUID()} rowContent={rowContent} index={idx} />
          </>
        })}
      </tbody>
    </table>
    {    
    tdCont.length > 3 ? <span className="text-[#033d9b] cursor-pointer font-bold text-right block py-2 pr-2" onClick={showMore}>{moreText}</span> : <></>}
    
    </>
    
  );
};
export default Table;